import { FC, ReactElement } from 'react'

import { ASSETS } from '../../constants'
import { PayloadProps } from '../../types/footer'
import Icon from '../atoms/images/icon'
import Image from '../atoms/images/image'

import './companyInfo.css'

const CompanyInfo: FC<PayloadProps> = (props: PayloadProps): ReactElement => {
  const { company } = props.payload
  const logoFile = 'kivuto-logo-white.svg'
  const logoSrc = `${ASSETS}/kivuto/logo/${logoFile}`
  const faceAlt = company?.socialIcons.facebook.name
  const twitAlt = company?.socialIcons.twitter.name
  const insAlt = company?.socialIcons.instagram.name
  const tikAlt = company?.socialIcons.tiktok.name
  const iconSize = 40

  return (
    <div className="company-info__container">
      <a className="company-info__icon__logo__link" href={company?.logo.url} style={{ marginBottom: 20 }} aria-label="Visit Kivuto website">
        <Image
          className="company-info__icon__logo"
          src={logoSrc}
          alt={company?.logo.name ? company.logo.name : 'Kivuto Logo'}
          size={{ width: 150, height: 60 }}
        />
      </a>
      <div aria-label={company?.addressLine1} className="address__one" role="note">
        {company?.addressLine1}
      </div>
      <div aria-label={company?.addressLine2} className="address__two" role="note">
        {company?.addressLine2}
      </div>

      <div className="company-info__icon__container">
        <a href={company?.socialIcons.facebook.url} aria-label="Facebook">
          <Icon
            className="company-info__icon__item"
            icon="social-media/facebook-white.svg"
            size={{ width: iconSize, height: iconSize }}
            alt={faceAlt ? faceAlt : 'facebook-icon'}
          ></Icon>
        </a>
        <a href={company?.socialIcons.twitter.url} aria-label="Tweeter">
          <Icon
            className="company-info__icon__item"
            icon="social-media/twitter-white.svg"
            size={{ width: iconSize, height: iconSize }}
            alt={twitAlt ? twitAlt : 'twitter-icon'}
          ></Icon>
        </a>
        <a href={company?.socialIcons.instagram.url} aria-label="Instagram">
          <Icon
            className="company-info__icon__item"
            icon="social-media/instagram-white.svg"
            size={{ width: iconSize, height: iconSize }}
            alt={insAlt ? insAlt : 'instagram-icon'}
          ></Icon>
        </a>
        <a href={company?.socialIcons.tiktok.url} aria-label="TikTok">
          <Icon
            className="company-info__icon__item"
            icon="social-media/tiktok-white.svg"
            size={{ width: iconSize, height: iconSize }}
            alt={tikAlt ? tikAlt : 'tiktok-icon'}
          ></Icon>
        </a>
      </div>
    </div>
  )
}

export default CompanyInfo
